import { render, staticRenderFns } from "./MonitoringLegacy.vue?vue&type=template&id=319af47e"
import script from "./MonitoringLegacy.vue?vue&type=script&lang=js"
export * from "./MonitoringLegacy.vue?vue&type=script&lang=js"
import style0 from "./MonitoringLegacy.vue?vue&type=style&index=0&id=319af47e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports